/**
 * Merges two arrays of the same type to produce a new array with distinct items from both arrays
 *
 * @param a The first array to merge
 * @param b The second array to merge
 * @param predicate (Optional) The predicate to perform comparision between array items
 * @returns A new array of the same type with distinct items from each array
 */
export const mergeArrays = <T>(a: T[], b: T[], predicate: (a: T, b: T) => boolean = (_a, _b) => _a === _b): T[] => {
    const c = [...a];
    b.forEach((bItem) => (c.some((cItem) => predicate(bItem, cItem)) ? null : c.push(bItem)));
    return c;
};
